const genericFunctionsDataTypes = {
  DATA_MODEL: 'DATA_MODEL',
  CONSTANT: 'CONSTANT',
  CONSOL_CONSTANT: 'CONSOL_CONSTANT',
};

module.exports = {
  genericFunctionsDataTypes,
};
